import { DrawableText, Drawer, lerp } from "@common/components/Rendering";
import { ArrowId, meassure_style, meassure_text_style } from "../ViewportStyles";

export const drawVerticalMeassurment = (
  g: Drawer<ArrowId>,
  sett: {
    start_hor?: number;
    end_hor: number;
    // small offset to not start directly at start and provide a small air gap
    alignment?: number;
    start_vert: number;
    end_vert: number;
    text: DrawableText;
    is_visible?: boolean;
    horiOffset?: number;
    vertOffset?: number;
  },
) => {
  const is_visible = sett.is_visible ?? true;
  const { start_hor: meassure_start_hor, end_hor: messure_end_hor, alignment: alignment_dist } = sett;

  // 2 lines going horizontal
  if (meassure_start_hor && alignment_dist) {
    for (const y of [sett.start_vert, sett.end_vert]) {
      g.drawLine([meassure_start_hor + alignment_dist, y], [messure_end_hor, y], meassure_style, {
        endArrow: "measure-extended",
        display: is_visible,
      });
    }
  } else if (is_visible) {
    g.drawSymbol([messure_end_hor, sett.start_vert], "measure-point-hor", { ...meassure_style, fill: `null` });
    g.drawSymbol([messure_end_hor, sett.end_vert], "measure-point-hor", { ...meassure_style, fill: `null` });
  }

  // actual vertical line
  g.drawLine([messure_end_hor, sett.start_vert], [messure_end_hor, sett.end_vert], meassure_style, {
    startArrow: "measure",
    endArrow: "measure",
    display: is_visible,
  });
  g.drawText([messure_end_hor, lerp(sett.start_vert, sett.end_vert, 0.5)], sett.text, meassure_text_style, {
    rotation: "upward",
    vertAlign: "bottom",
    horiAlign: "center",
    display: is_visible,
    horiOffset: sett.horiOffset ?? 0,
    vertOffset: sett.vertOffset ?? 0,
    id: "vertical-meassurement",
  });
};

export const drawHorizontalMeassurment = (
  drawer: Drawer<ArrowId>,
  sett: {
    start_hor: number;
    end_hor: number;
    // small offset to not start directly at start and provide a small air gap
    alignment?: number;
    start_vert?: number;
    end_vert: number;
    text: DrawableText;
    is_visible?: boolean;
    // horizontal offset (pixels) applied to the distance text only, positive = to the right
    textHoriOffset?: number;
  },
) => {
  const is_visible = sett.is_visible ?? true;
  //   horizontal measurement line
  if (sett.start_vert && sett.alignment) {
    for (const x of [sett.start_hor, sett.end_hor]) {
      // 2 lines going down
      drawer.drawLine([x, sett.start_vert + sett.alignment], [x, sett.end_vert], meassure_style, {
        endArrow: "measure-extended",
        display: is_visible,
      });
    }
  } else if (is_visible) {
    drawer.drawSymbol(
      [sett.start_hor, sett.end_vert],
      "measure-point-hor",
      { ...meassure_style, fill: `null` },
      { degrees: 90 },
    );
    drawer.drawSymbol(
      [sett.end_hor, sett.end_vert],
      "measure-point-hor",
      { ...meassure_style, fill: `null` },
      { degrees: 90 },
    );
  }
  //   actual horizontal line
  drawer.drawLine([sett.start_hor, sett.end_vert], [sett.end_hor, sett.end_vert], meassure_style, {
    startArrow: "measure",
    endArrow: "measure",
    display: is_visible,
  });
  drawer.drawText([lerp(sett.start_hor, sett.end_hor, 0.5), sett.end_vert], sett.text, meassure_text_style, {
    vertAlign: "bottom",
    display: is_visible,
    horiOffset: sett.textHoriOffset ?? 0,
    id: "horizontal-meassurement",
  });
};
